/**
 * Admin Route Guard
 *
 * Restricts access to admin pages to authorized users only.
 * Redirects unauthorized users to the dashboard.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// List of authorized admin emails
const ADMIN_EMAILS = [
  'chris@uknew.net'
];

export default function AdminRoute({ children }) {
  const { currentUser } = useAuth();

  // Check if user is logged in and is an admin
  const isAdmin = currentUser && ADMIN_EMAILS.includes(currentUser.email?.toLowerCase());

  if (!isAdmin) {
    // Redirect to dashboard if not admin
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
